import {firestore} from 'firebase/firebase.js'

const state = {
  avatarURLs: {}
}

const getters = {
  userAvatar (state, rootState) {
    return rootState.user
  }
  // avatarByUID
}
const actions = {
  storeUsersAvatar ({commit}, payload) {
    var avatarRef = firestore.storage().child(payload.path)
    avatarRef.put(payload.image).then(function (snapshot) {
      console.log('Avatar saved')
    })
  },
  fetchAvatar ({commit}, payload) {
    let avatarRef = firestore.storage().ref().child('images/avatar/' + payload)
    let avatarURL = avatarRef.getDownloadURL()
    console.log(avatarURL)
  }
}
const mutations = {
}
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/avatar.js